import { render } from "./CommentSuggestInput.vue?vue&type=template&id=6cfa38fb&scoped=true"
import script from "./CommentSuggestInput.vue?vue&type=script&lang=js"
export * from "./CommentSuggestInput.vue?vue&type=script&lang=js"

import "./CommentSuggestInput.vue?vue&type=style&index=0&id=6cfa38fb&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6cfa38fb"]])

export default __exports__